import React from 'react'
import { connect } from 'react-redux'
import { graphql } from 'gatsby'
import styled from '@emotion/styled'
import { Layout } from 'components'
import * as Boxes from 'components/theme/Boxes'
import { SEO, Hero } from 'components/common'
import { ProgressCircle, SimpleBlock } from 'components/theme/Elements'
import * as UI from 'components/common/LayoutElements'
import * as Buttons from 'components/theme/Buttons'
import { PageWrapper, Section, RowSmallGap, Column3, Column4 } from 'components/theme/Layout'
import { Content, Headline } from 'components/theme/Content'
import CircularProgress from '@material-ui/core/CircularProgress';
import * as Cta from 'components/common/Cta'
import { Badge } from 'components/theme'
import AOS from 'aos';
import * as Logos from 'components/theme/Logos'
import { handleSimulatorPresets } from 'actions/simulator'
import ContactBanner from 'components/common/ContactBanner'
import Modal from 'components/common/alerts/ModalDefault'
import { handleModal } from 'actions/modal';

import meta from '../../config/meta.json'

const ModalWrapper = styled.div`
  display: flex;
  > div {
    height: 37.5rem;
    width: 50rem;
    margin: 0 1rem;
    
    &.fullwidth {
      width: 100%;
      min-width: 80rem;
    }
  }
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    display: block;
    > div {
      width: 100%;
      margin: 0;
      height: auto;
      .full.padding {
        padding-top: 0!important;
      }
    }
  }
`;

class Media extends React.Component {

  constructor(props) {
    super(props);
    props.handleSimulatorPresets({ campaignType: 'media', category: null })
  }

  componentDidMount() {
    AOS.init({
      duration: 1000,
      once: true
    });
  }

  UNSAFE_componentWillReceiveProps() {
    AOS.refresh();
  }

  render() {
    const { pageContext, location, data } = this.props;

    const hero = data.backgrounds.edges.filter((item) => item.node.name === 'media_header')[0].node;
    const backgrounds = {
      'default': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'background_1')[0].node,
      'footer': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'background_2')[0].node,
      'orange': data.backgrounds.edges.filter((item) => item.node.name === 'cas_7')[0].node,
      'leroymerlin': data.backgrounds.edges.filter((item) => item.node.name === 'cas_2')[0].node,
      'kontron': data.backgrounds.edges.filter((item) => item.node.name === 'cas_6')[0].node,
      'section4': data.backgrounds.edges.filter((item) => item.node.name === 'media_illu_1')[0].node,
    };
    const logos = {
      'Aramis-auto': data.__logos.edges.filter((item) => item.node.name === 'aramis-auto')[0].node.publicURL,
      'Axa': data.__logos.edges.filter((item) => item.node.name === 'axa')[0].node.publicURL,
      'Manomano': data.__logos.edges.filter((item) => item.node.name === 'manomano')[0].node.publicURL,
      'sgvc': data.__logos.edges.filter((item) => item.node.name === 'sgvc')[0].node.publicURL,
      'Transavia': data.__logos.edges.filter((item) => item.node.name === 'transavia')[0].node.publicURL,
      'Orange': data.__logos.edges.filter((item) => item.node.name === 'orange')[0].node.publicURL
    }

    return (
      <Layout context={pageContext} location={location}>
        <SEO title={meta.media.title} description={meta.media.description} />
        <Hero image={hero.publicURL}>
          <div className="card">
            <SimpleBlock>
              <Badge className="grey blue">Campagnes média</Badge>
            </SimpleBlock>
            <div>
              <h1>
                <span>
                  Choisissez le plus grand réseau d’affichage de France.
                </span>
              </h1>
            </div>
            <Content className="full padding xs">
              <p>
                Partout sur le territoire, dans les villes et les quartiers
                les plus prestigieux et les communes les plus reculées.
                Une audience massive et mesurée, à un pas de l’achat.
              </p>
            </Content>
            <Content className="full padding xs">
              <Buttons.ButtonDefaultLinkGatsby to="/simulation/">
                Je démarre ma simulation
              </Buttons.ButtonDefaultLinkGatsby>
            </Content>
          </div>
        </Hero>

        <PageWrapper>
          <Section className="top main background-default" style={{
            backgroundImage: `url(${backgrounds.default.publicURL})`,
          }}>
            <Headline className="center padding l" style={{ padding: '5rem 0' }}>
              <h2>
                <span>
                  Le plus grand réseau OOH...
                </span>
              </h2>
              <p>
                <span>Prenez la parole de façon globale ou ultra locale</span>
                &nbsp;et générez des intéractions avec vos audiences.
              </p>
            </Headline>
            <div data-aos="fade-up">
              <RowSmallGap>
                <Column3 className="smallGap">
                  <Boxes.BoxShadow className="columns min-height">
                    <h2><small>Le + grand réseau d’affichage en France</small></h2>
                    <ProgressCircle>
                      <section>
                        <div>
                          <span>1,8<small>M</small></span>
                          <span>Faces</span>
                        </div>
                      </section>
                      <CircularProgress variant="static" value={99} />
                    </ProgressCircle>
                  </Boxes.BoxShadow>
                </Column3>

                <Column3 className="smallGap">
                  <Boxes.BoxShadow className="columns min-height">
                    <h2><small>La + grande surface de prise de parole en ville</small></h2>
                    <ProgressCircle>
                      <section>
                        <div>
                          <span>4,2<small>m²</small></span>
                          <span>Surface moy.</span>
                        </div>
                      </section>
                      <CircularProgress variant="static" value={85} />
                    </ProgressCircle>
                  </Boxes.BoxShadow>
                </Column3>

                <Column3 className="smallGap">
                  <Boxes.BoxShadow className="columns min-height">
                    <h2><small>Couverture nationale et ultra locale</small></h2>
                    <ProgressCircle>
                      <section>
                        <div>
                          <span><small></small></span>
                          <span>Granularité<br />maximum</span>
                        </div>
                      </section>
                      <CircularProgress variant="static" value={97} />
                    </ProgressCircle>
                  </Boxes.BoxShadow>
                </Column3>

                <Column3 className="smallGap">
                  <Boxes.BoxShadow className="columns min-height">
                    <h2><small>La media le + apprécié des français</small></h2>
                    <ProgressCircle>
                      <section>
                        <div>
                          <span>32<small>%</small></span>
                          <span>préfèrent la vitrine à tout autre média</span>
                        </div>
                      </section>
                      <CircularProgress variant="static" value={32} />
                    </ProgressCircle>
                  </Boxes.BoxShadow>
                </Column3>
              </RowSmallGap>
            </div>
          </Section>

          <Section className="no-margin main background-default" style={{
            backgroundImage: `url(${backgrounds.default.publicURL})`,
            backgroundPosition: 'bottom center',
            paddingBottom: '38rem'
          }}>
            <Headline className="center padding l" style={{ padding: '5rem 0 11rem' }} data-aos="fade-up">
              <h2><span>Touchez une audience difficile à atteindre</span></h2>
              <p>
                Allez là où personne ne peut aller. <br />
                <span>Touchez ceux que vous voulez vraiment toucher.</span>
              </p>
            </Headline>

            <div style={{ marginTop: '-5rem' }} data-aos="fade-up">
              <RowSmallGap className="centered">
                <Column4 className="smallGap">
                  <Boxes.BoxDefault className="full shadow split small-gap">
                    <div>
                      <h2 className="badge"><small>Petites et moyennes communes</small></h2>
                      <Content>
                        <p>
                          <strong>
                            Communiquez auprès des populations de petites et moyennes communes.
                          </strong>
                        </p>
                        <p>
                          Un commerce est une opportunité de prise de parole. Nous gérons tout.
                        </p>
                      </Content>
                    </div>
                    <Boxes.BoxFooter className="right">
                      <div style={{
                        backgroundImage: `url(${backgrounds.orange.publicURL})`,
                        backgroundSize: '110%',
                        backgroundPosition: 'top 50px left -20px'
                      }}>
                        <Cta.CtaContainer>
                          <Cta.ChevronCta href='/orange/'>Orange</Cta.ChevronCta>
                        </Cta.CtaContainer>
                      </div>
                    </Boxes.BoxFooter>
                  </Boxes.BoxDefault>
                </Column4>

                <Column4 className="smallGap">
                  <Boxes.BoxDefault className="full shadow split small-gap">
                    <div>
                      <h2 className="badge"><small>Rues et quartiers</small></h2>
                      <Content>
                        <p>
                          <strong>
                            Boostez votre visibilité dans une zone circonscrite de façon éphémère.
                          </strong>
                        </p>
                        <p>
                          Arrondissement ou quartier chic de grande ville.
                        </p>
                      </Content>
                    </div>
                    <Boxes.BoxFooter className="right">
                      <div style={{
                        backgroundImage: `url(${backgrounds.leroymerlin.publicURL})`,
                        backgroundSize: '130%',
                        backgroundPosition: 'top 20px left -50px'
                      }}>
                        <Cta.CtaContainer>
                          <Cta.ChevronCta href='/leroy-merlin/'>Leroy Merlin</Cta.ChevronCta>
                        </Cta.CtaContainer>
                      </div>
                    </Boxes.BoxFooter>
                  </Boxes.BoxDefault>
                </Column4>

                <Column4 className="smallGap">
                  <Boxes.BoxDefault className="full shadow split small-gap grey">
                    <div>
                      <h2 className="badge"><small>L'idée intéressante...</small></h2>
                      <Content>
                        <p>
                          <strong>
                            Communiquez autour des sièges sociaux de vos prospects pour les stimuler.
                          </strong>
                        </p>
                      </Content>
                    </div>
                    <Boxes.BoxFooter className="right">
                      <div style={{
                        backgroundImage: `url(${backgrounds.kontron.publicURL})`,
                        backgroundSize: '100%',
                        backgroundPosition: 'top 70px left'
                      }}>
                        <Cta.CtaContainer>
                          <Cta.ChevronCta href='/kontron/'>Kontron software</Cta.ChevronCta>
                        </Cta.CtaContainer>
                      </div>
                    </Boxes.BoxFooter>
                  </Boxes.BoxDefault>
                </Column4>
              </RowSmallGap>
            </div>
          </Section>

          <Section className="no-margin main background-default" style={{
            backgroundImage: `url(${backgrounds.default.publicURL})`,
            padding: '0 0 30rem',
            backgroundPosition: 'bottom -5rem center'
          }}>
            <Headline className="center padding l" style={{ padding: '5rem 0' }} data-aos="fade-up">
              <h2><span>Générez du Drive-...</span></h2>
              <p>
                <span>Booster votre trafic et vos ventes</span> <br />en attirant le monde autour de vous.
              </p>
            </Headline>

            <div data-aos="fade-up">
              <RowSmallGap className="centered">
                <Column4>
                  <Boxes.BoxShadow className="columns min-height">
                    <h2 className="rounded-small">... to-Store</h2>
                    <Boxes.BoxList className="offers center">
                      <li>
                        Vous ouvrez un ou plusieurs magasins
                      </li>
                      <li>
                        Vous avez besoin d’une communication locale visible et puissante
                      </li>
                      <li>
                        Vous voulez générer du trafic et des ventes en magasin
                      </li>
                    </Boxes.BoxList>
                  </Boxes.BoxShadow>
                </Column4>

                <Column4>
                  <Boxes.BoxShadow className="columns min-height">
                    <h2 className="rounded-small">... to-Monument</h2>
                    <Boxes.BoxList className="offers center">
                      <li>
                        Vous cherchez plus de visiteurs
                      </li>
                      <li>
                        Vous voulez accroître leur fidélité
                      </li>
                      <li>
                        Vous cherchez à communiquer dans votre quartier et alentours
                      </li>
                    </Boxes.BoxList>
                  </Boxes.BoxShadow>
                </Column4>

                <Column4>
                  <Boxes.BoxShadow className="columns min-height">
                    <h2 className="rounded-small">... to-Event</h2>
                    <Boxes.BoxList className="offers center">
                      <li>
                        Vous chercher à booster l’afflux de visiteurs (tournoi, Salon, soirée, ...)
                      </li>
                      <li>
                        Les commerces alentours sont vos alliés
                      </li>
                      <li>
                        Communiquez une ou deux semaines avant votre événement
                      </li>
                    </Boxes.BoxList>
                  </Boxes.BoxShadow>
                </Column4>
              </RowSmallGap>
            </div>
            <Headline className="center">
              <p style={{ paddingTop: '5rem' }}>
                <Buttons.ButtonDefault style={{ margin: '0 auto' }} className="medium" onClick={this.props.handleModal}>
                  En savoir Plus
                </Buttons.ButtonDefault>
              </p>
            </Headline>

            <Modal height={55}>
              <ModalWrapper>
                <div>
                  <Content className="full padding s">
                    <h3>Le plus beau, c'est d'observer le gain de trafic</h3>
                    <p>- nous déterminons un périmètre autour du ou des points de destination</p>
                    <p>- nous identifions et sélectionnons des vitrines que nous réservons et décorons</p>
                    <p>- nous positionnons un capteur de radiofréquence Wifi dans chacune des vitrines de la campagne ainsi que dans le(s) point(s) de destination</p>
                    <p>- nous croisons les data pour déterminer le trafic entrant qui est passé devant les vitrines de la campagne</p>
                    <p>- Plus de doute, nous savons dire à quel point la campagne a été performante !</p>
                  </Content>
                </div>
                <div>
                  <img src={data.__customerCase.edges[0].node.publicURL} alt="Leroy Merlin" />
                </div>
              </ModalWrapper>
            </Modal>
          </Section>

          <Section className="no-margin main contain" style={{
            background: `url(${backgrounds.section4.publicURL})`,
            backgroundSize: '80rem',
            backgroundPosition: 'top right',
            backgroundRepeat: 'no-repeat no-repeat',
            padding: '10rem 0 20rem'
          }}>
            <div data-aos="fade-up">
              <Boxes.Box2Columns style={{ padding: '3rem 6rem' }}>
                <div>
                  <Content>
                    <h3 style={{ fontSize: '3rem' }}>
                      Média à très forte audience
                    </h3>
                    <p>
                      <strong>
                        800 000 commerces et restaurants en France, soit près de 2M de vitrines.
                      </strong>
                    </p>
                    <p>
                      8 000 ODV/jour en moyenne dans les grandes villes.
                    </p>
                    <p>
                      Récolte des radiofréquences Wifi émises par les smartphones des passants pour calculer les passages et la répétition
                    </p>
                  </Content>
                </div>
              </Boxes.Box2Columns>
              <Boxes.Box2Columns>
              </Boxes.Box2Columns>
            </div>
            <div data-aos="fade-up">
              <Boxes.Box2Columns style={{ padding: '3rem 6rem' }}>
                <div>
                  <Content>
                    <h3 style={{ fontSize: '3rem' }}>
                      Media contextuel et interactif
                    </h3>
                    <p>
                      <strong>
                        Le type de commerces ou sa notoriété contextualise et enrichit votre message.
                      </strong>
                    </p>
                    <p>
                      Le commerçant est prescripteur auprès de ses clients.
                    </p>
                  </Content>
                </div>
              </Boxes.Box2Columns>
            </div>
            <div data-aos="fade-up">
              <Boxes.Box2Columns style={{ padding: '3rem 6rem' }}>
                <div>
                  <Content>
                    <h3 style={{ fontSize: '3rem' }}>
                      Media qui convertit l’audience en acheteurs immédiats
                    </h3>
                    <p>
                      <strong>
                        La campagne peut être déployée chez vos commerçants clients ou prospects
                      </strong>
                    </p>
                    <p>
                      Le viewer franchit le pas de la porte pour devenir shopper
                    </p>
                  </Content>
                </div>
              </Boxes.Box2Columns>
              <Boxes.Box2Columns>
              </Boxes.Box2Columns>
            </div>
          </Section>

          <Section className="no-margin main background-default" style={{
            backgroundImage: `url(${backgrounds.default.publicURL})`,
            backgroundPosition: 'top center',
            paddingBottom: '10rem'
          }}>
            <Headline className="center padding l" style={{ padding: '5rem 0 10rem' }} data-aos="fade-up">
              <h3><span>Comment ça marche ?</span></h3>
            </Headline>
            <div style={{ paddingBottom: '10rem' }} data-aos="fade-up">
              <RowSmallGap>
                <Column3 className="smallGap" data-aos="fade-up">
                  <Boxes.BoxShadow className="columns" style={{ minHeight: '42rem' }}>
                    <span className="icon"><i>1</i></span>
                    <h3>Vous nous briefez</h3>
                    <Boxes.BoxList className='offers'>
                      <li>
                        <UI.BulletPointDefault>
                          Ciblage de géographie, de profil d’audience, de typologies de commerce
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Période, budget, objectifs poursuivis
                        </UI.BulletPointDefault>
                      </li>
                    </Boxes.BoxList>
                  </Boxes.BoxShadow>
                </Column3>
                <Column3 className="smallGap" data-aos="fade-up" data-aos-delay="100">
                  <Boxes.BoxShadow className="columns" style={{ minHeight: '42rem' }}>
                    <span className="icon"><i>2</i></span>
                    <h3>Nous réservons <br />les vitrines</h3>
                    <Boxes.BoxList className='offers'>
                      <li>
                        <UI.BulletPointDefault>
                          Envoi d’un email de réservation à tous les commerçants ciblés
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Réponses des commerçants online
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Horodatage des accords
                        </UI.BulletPointDefault>
                      </li>
                    </Boxes.BoxList>
                  </Boxes.BoxShadow>
                </Column3>
                <Column3 className="smallGap" data-aos="fade-up" data-aos-delay="200">
                  <Boxes.BoxShadow className="columns" style={{ minHeight: '42rem' }}>
                    <span className="icon"><i>3</i></span>
                    <h3>Nous installons <br />la campagne</h3>
                    <Boxes.BoxList className='offers'>
                      <li>
                        <UI.BulletPointDefault>
                          BAT, fabrication, installation
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Synchronisation des mises en place partout en France
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Déploiement des capteurs d’audience
                        </UI.BulletPointDefault>
                      </li>
                    </Boxes.BoxList>
                  </Boxes.BoxShadow>
                </Column3>
                <Column3 className="smallGap" data-aos="fade-up" data-aos-delay="300">
                  <Boxes.BoxShadow className="columns" style={{ minHeight: '42rem' }}>
                    <span className="icon"><i>4</i></span>
                    <h3>Nous remontons les metrics</h3>
                    <Boxes.BoxList className='offers'>
                      <li>
                        <UI.BulletPointDefault>
                          Nous interrogeons tous les commerçants pour avoir leurs feedbacks en 10 questions
                        </UI.BulletPointDefault>
                      </li>
                      <li>
                        <UI.BulletPointDefault>
                          Nous vous fournissons un rapport avec photographies,
                          audiences, réponses au sondage, statistiques
                        </UI.BulletPointDefault>
                      </li>
                    </Boxes.BoxList>
                  </Boxes.BoxShadow>
                </Column3>
              </RowSmallGap>
            </div>
          </Section>

          <Section className="top no-flex" style={{ paddingBottom: '20rem' }}>
            <div style={{ display: 'flex' }}>
              <Boxes.Box2Columns style={{ paddingLeft: 0, display: 'flex', alignItems: 'center' }} data-aos="fade-up">
                <div>
                  <Content className="full padding s" data-aos="fade-up">
                    <h3>Découvrez quelques cas clients</h3>
                    <p>
                      <span>À chaque client sa problématique media.</span><br />
                      Découvrez quelques illustrations de notre champ d'action.
                    </p>
                  </Content>
                </div>
              </Boxes.Box2Columns>

              <Boxes.Box2Columns style={{ padding: 0, overflow: 'initial' }} data-aos="fade-up">
                <Logos.LogosContainer>
                  <a href="/aramisauto/" target="_blank">
                    <Logos.LogoLarge img={logos['Aramis-auto']} top={-20} left={100} shadow={0.05} animationTime={2} />
                  </a>
                  <a href="/axa/" target="_blank">
                    <Logos.LogoMedium img={logos.Axa} top={130} left={0} shadow={0.03} size={50} animationTime={4} />
                  </a>
                  <a href="/manomano/" target="_blank">
                    <Logos.LogoLarge img={logos.Manomano} top={110} left={330} shadow={0.03} animationTime={3} />
                  </a>
                  <a href="/orange/" target="_blank">
                    <Logos.LogoSmall img={logos.Orange} top={160} left={180} shadow={0.05} size={50} animationTime={5} />
                  </a>
                  <a href="/transavia/" target="_blank">
                    <Logos.LogoMedium img={logos.Transavia} top={300} left={150} shadow={0.05} animationTime={4} />
                  </a>
                </Logos.LogosContainer>
              </Boxes.Box2Columns>
            </div>
          </Section>

          <Section className="bottom">
            <div>
              <Boxes.BoxLargeShadow className="cta" style={{ width: '100%' }} data-aos="fade-up">
                <div>
                  <Content>
                    <h2>Faites une simulation</h2>
                    <p>
                      Je simule le montage d’une campagne
                      <br />pour voir combien de vitrines je pourrais avoir
                      en fonction de mes critères...
                    </p>
                  </Content>
                </div>
                <Buttons.ButtonDefaultLinkGatsby
                  style={{
                    border: '1px solid white', color: 'white', background: 'transparent', marginTop: '4rem'
                  }}
                  to="/simulation/"
                >
                  Je démarre ma simulation
                </Buttons.ButtonDefaultLinkGatsby>
              </Boxes.BoxLargeShadow>

              <Boxes.BoxLarge style={{ width: '100%' }} data-aos="fade-up">
                <div>
                  <Content>
                    <h2 style={{ textAlign: 'center' }}>Découvrez le simulateur en vidéo avant de vous lancer</h2>
                    <div style={{
                      padding: '0 0 0 0',
                      maxWidth: '100%',
                      marginTop: '5rem',
                      position: 'relative',
                      display: 'block'
                    }}>
                      <video
                        controls
                        style={{
                          margin: '0 auto',
                          outline: 'none',
                          display: 'block',
                          minWidth: '25rem',
                          maxWidth: '80rem',
                          boxShadow: '0 24px 32px 0 rgba(0,0,0,0.1), 0 8px 32px 0 rgba(0,0,0,0.1)'
                        }}>
                        <source
                          src="https://www.messageinawindow.com/videos/Media V2.mp4"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </Content>
                </div>
              </Boxes.BoxLarge>
            </div>
          </Section>

          <Section className="no-margin main background-footer" style={{
            backgroundImage: `url(${backgrounds.footer.publicURL})`,
            padding: '0 0 10rem'
          }}>
            <Headline className="center padding l" data-aos="fade-up">
              <h3 className="dark-blue">Nous contacter</h3>
            </Headline>
            <ContactBanner />
          </Section>
        </PageWrapper>
      </Layout>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  handleSimulatorPresets: (state) => dispatch(handleSimulatorPresets(state)),
  handleModal: () => dispatch(handleModal())
});
const mapStateToProps = (state) => ({
  ...state.anchor
});
export default connect(mapStateToProps, mapDispatchToProps)(Media);

export const query = graphql`
  query {
    backgrounds: allFile (
      filter: {
        relativeDirectory: {eq: "pages/campagnes-media"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
    __commonBackgrounds: allFile (
      filter: {
        relativeDirectory: {eq: "backgrounds/common"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
    __logos: allFile (
      filter: {
        relativeDirectory: {eq: "logos/media/clients"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
    __customerCase: allFile (
      filter: {
        relativePath: {eq: "cas-clients/leroy-merlin.jpg"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
  }
`